import { styled } from '@mui/material/styles';

export const TabPanelStyled = styled('div')<{ isActive: boolean }>`
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
`;
